import { createAuthInstance, createXSRFInstance } from 'axios-interceptor'

export default {
  namespaced: true,

  state: {
    self_attested: {
      'basic_info|other_names': []
    }
  },

  mutations: {
    setData (state, attrs) {
      state.self_attested[attrs.key] = attrs.val
    },
    addAttestedAlias (state, alias) {
      state.self_attested['basic_info|other_names'].push(alias)
    }
  },

  actions: {
    patchAlias (context, providerID) {
      const axios = createAuthInstance(context, createXSRFInstance())
      const data = {}

      data['basic_info|other_names'] = context.state.self_attested['basic_info|other_names']

      return axios({
        method: 'post',
        url: `/api/add_alias/${providerID}`,
        data: {
          data
        }
      })
    }
  }
}
